import * as React from 'react';
import { Form, Formik } from 'formik';
import { REPORT_TYPE_SERVER_TO_CLIENT_MAPPING } from 'Src/consts/report';
import { Team } from 'Src/models/team';
import {
  ReportActions,
  ReportDateRange,
  ReportDescription,
  ReportSection,
  ReportToggle,
  ReportToggleList
} from '../../../Events/SchoolEventView/Reports/ReportFormUi';
import '../../../Events/SchoolEventView/SchoolEventView.scss';

interface Props {
  onCloseClick: () => void;
  onSubmit: (data: any, reportType: string) => void;
  team: Team;
}

export function TeamFixtureCardsReportForm(props: Props) {
  const today = new Date();
  const oneYearFromNow = new Date(today);
  oneYearFromNow.setFullYear(today.getFullYear() + 1);

  return (
    <Formik
      initialValues={{ dateFrom: today, dateTo: oneYearFromNow, includeCancelled: false }}
      onSubmit={values => props.onSubmit(values, REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.TEAM_FIXTURE_CARDS)}
    >
      {({ values, setFieldValue }) => (
        <Form className="eReportForm">
          <ReportDescription>
            Create a print-ready PDF with one fixture card for every event involving {props.team?.name || 'the selected team'}.
            External, multi-school, internal-team and house fixtures are laid out automatically.
          </ReportDescription>
          <ReportSection number={1} title="Fixture period" hint="Only fixtures in this date range will be included.">
            <ReportDateRange
              dateFrom={values.dateFrom}
              dateTo={values.dateTo}
              onChangeFrom={date => {
                setFieldValue('dateFrom', date);
                if (values.dateTo < date) setFieldValue('dateTo', date);
              }}
              onChangeTo={date => setFieldValue('dateTo', date)}
            />
          </ReportSection>
          <ReportSection number={2} title="Cancelled fixtures" hint="Cancelled events are excluded by default.">
            <ReportToggleList>
              <ReportToggle
                name="includeCancelled"
                label="Include cancelled fixtures"
                hint="They will be clearly marked and visually separated in the PDF."
                value={values.includeCancelled}
                onChange={value => setFieldValue('includeCancelled', value)}
              />
            </ReportToggleList>
          </ReportSection>
          <ReportActions onCancel={props.onCloseClick} submitLabel="Generate PDF" />
        </Form>
      )}
    </Formik>
  );
}
